<template>
	<div class="ui inline search dropdown manager-school-picker" :class="{ loading: loading }">
		<div class="text" style="min-width: 8em;"></div>
		<i class="dropdown icon" />
		<div class="menu" style="z-index: 10000;">
			<school-dropdown-item v-for="school in schools" :key="school.jobId" :school="school" />
		</div>
	</div>
</template>

<script>
import SchoolDropdownItem from './SchoolDropdownItem.vue';

export default {
	props: {
		schools: {
			default: function() {
				return [];
			}
		},
		loading: {
			default: false
		}
	},
	data: function() {
		return {
			defaultJob: null
		};
	},
	watch: {
		schools: function(newSchools, oldSchools) {
			if(newSchools != oldSchools) {
				this.initSchools();
			}
		}
	},
	methods: {
		initSchools: function() {
			var dropdown = $(this.$el);
			if(this.schools.length) {
				this.defaultJob = window.managerSchoolGetDefaultSchool(this.schools);

				this.$nextTick(() => {
					dropdown.dropdown('refresh');
					dropdown.dropdown('set selected', this.defaultJob.jobId);
				});
			} else if(dropdown.dropdown('get value')) {
				dropdown.dropdown('set exactly', null);
			}
		}
	},
	mounted: function() {
		var me = this;
		$(this.$el).dropdown({
			forceSelection: false,
			fullTextSearch: 'exact',
			match: 'text',
			onChange: function (value, text, elem) {
				var school = me.schools.filter(function(school) {
					return school.jobId == value;
				})[0];

				if(school) {
					if(!$.currentSetSeason && school != me.defaultJob) {
						me.defaultJob = school;
						window.managerSchoolSaveDefaultSchool(school);
					}
				}

				$(me).find('input').blur();
				me.$emit('schoolChanged', school);
			}
		});
		$.managerSchoolDropdown = $(this.$el);

		window.selectSchoolInDropdown = function(school) {
			$(me.$el).dropdown('set selected', school.jobId);
		};

		this.initSchools();
	},
	components: {
		SchoolDropdownItem
	}
};

window.managerSchoolGetDefaultSchool = function(schools) {
	var defaultJob = schools[0];

	var lookupJobId = $.getGETParams().jobId;
	if(!lookupJobId && !$.currentSetSeason && $.userExtras.managerLastSchools && $.userExtras.managerLastSchools.length) {
		lookupJobId = $.userExtras.managerLastSchools[0];
	}
	if(lookupJobId) {
		for(var i = 0; i < schools.length; i++) {
			var school = schools[i];
			if(school.jobId == lookupJobId) {
				defaultJob = school;
				if($.getGETParams().jobId) {
					window.managerSchoolSaveDefaultSchool(defaultJob);
				}
				break;
			}
		}
	}
	if($.getGETParams().plicProjectId) {
		var lookupProjectId = $.getGETParams().plicProjectId;
		schools.forEach(function(school) {
			if(school.plicProjectId === lookupProjectId) {
				defaultJob = school;
				window.managerSchoolSaveDefaultSchool(defaultJob);
			}
		});
	}

	return defaultJob;
}
window.managerSchoolSaveDefaultSchool = function(school) {
	if($.userExtras.managerLastSchools) {
		$.userExtras.managerLastSchools[0] = school.jobId;
	} else {
		$.userExtras.managerLastSchools = [school.jobId];
	}

	$.ajax({
		url: 'ajax/saveUserExtra.php',
		dataType: 'json',
		data: {
			name: 'managerLastSchools',
			value: [school.jobId]
		},
		type: 'POST'
	});
}
</script>

<style scoped>
.manager-school-picker {
	white-space: nowrap;
}
</style>